import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

function REPORT_SEARCH_START(state, action) {
	const {
		reportSearchId,
		description,
		joinpathIds,
		libraryName,
		name,
		tabIds,
		title,
		longDescription,
		exampleUrl,
		comparison,
	} = action;

	const nextState = { ...state };
	nextState[reportSearchId] = {
		__id: reportSearchId,
		description,
		joinpathIds,
		libraryName,
		name,
		tabIds,
		title,
		longDescription,
		exampleUrl,
		comparison,
	};

	return nextState;
}

function REPORT_SEARCH_DELETE(state, action) {
	const { reportSearchId } = action;
	const nextState = { ...state };
	delete nextState[reportSearchId];
	return nextState;
}

const handlers = {};
handlers[actionTypes.REPORT_SEARCH_DELETE] = REPORT_SEARCH_DELETE;
handlers[actionTypes.REPORT_SEARCH_START] = REPORT_SEARCH_START;
export default createReducer(defaultState, handlers);
